import React, { useState } from 'react';

import Button, { TButtonProps } from '@r1-frontend/ui-react/components/buttons/button';
import { TAutocompleteField } from '@r1-frontend/ui-react/organisms/Forms/PersonForm/Autocomplete/types';
import checkFioIsValid from '@r1-frontend/ui-react/organisms/Forms/PersonForm/helpers/checkFioIsValid';
import trimExtraSymbols from '@r1-frontend/ui-react/organisms/Forms/PersonForm/helpers/trimExtraSymbols';

import * as ST from './styled';

export interface IPersonFormProps {
    fio: string,
    phone: string,
    onChangeFio: (str: string) => void,
    onChangePhone: (str: string) => void,
    isNeedToBlockInvalidFio?: boolean,
    actionButtonProps?: Pick<TButtonProps, 'children' | 'disabled' | 'onClick'> | undefined,
    onLoadSuggestions: (input: string) => Promise<string[]>,
}

export const PersonForm = ({
    fio,
    phone,
    onChangeFio,
    onChangePhone,
    isNeedToBlockInvalidFio = false,
    actionButtonProps,
    onLoadSuggestions,
}: IPersonFormProps): JSX.Element => {
    const [fioInputData, setFioInputData] = useState<TAutocompleteField>({
        value: fio,
        isNotValid: false,
    });

    const changePhoneHandler = ({ value }: { value: string }) => {
        onChangePhone(value);
    };

    const changeFioHandler = (_person:string) => {
        if (isNeedToBlockInvalidFio) {
            const isReadyToInput = checkFioIsValid(_person);

            if (isReadyToInput) {
                const isNotValid = _person.length === 1;

                setFioInputData((prev) => ({
                    ...prev,
                    value: _person,
                    isNotValid,
                }));
                onChangeFio(trimExtraSymbols(_person));
            }
        } else {
            onChangeFio(_person);
        }

    };

    const onBlurHandler = () => {
        if (isNeedToBlockInvalidFio) {
            setFioInputData((prev) => ({
                ...prev,
                value: trimExtraSymbols(fioInputData.value),
            }));
        }
    };

    return (
        <>
            <ST.PersonForm>
                <ST.SAutocomplete
                    onLoadSuggestions={onLoadSuggestions}
                    placeholder='Фамилия Имя Отчество'
                    value={isNeedToBlockInvalidFio ? fioInputData.value : fio}
                    onChange={changeFioHandler}
                    onBlur={onBlurHandler}
                    data-test='fio'
                    className={'ym-disable-keys'}
                />
                <ST.PhoneField
                    name='phone'
                    placeholder='Номер телефона'
                    initialValue={phone}
                    onChange={changePhoneHandler}
                    errorMessage='Телефон в формате +7 (999) 999-99-99'
                    data-test='phone'
                    className={'ym-disable-keys'}
                />
            </ST.PersonForm>
            {actionButtonProps &&
                <Button
                    disabled={actionButtonProps.disabled || (isNeedToBlockInvalidFio && fioInputData.isNotValid)}
                    onClick={actionButtonProps.onClick}
                >{actionButtonProps.children}</Button>
            }
        </>
    );
};
